import { newrelic } from "@jti/fe-clients";
export const fromMagentoPickupInformation = (pickupInformation) => {
    if (!pickupInformation) {
        return undefined;
    }
    try {
        const { store_id, store_name } = JSON.parse(pickupInformation);
        return {
            id: store_id,
            name: store_name,
        };
    }
    catch (error) {
        if (error instanceof Error) {
            newrelic.noticeError(error);
        }
        console.error(error);
        return undefined;
    }
};
//# sourceMappingURL=fromMagentoPickupInformation.js.map